import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppBubble from "./WhatsAppBubble";
import ChatWidget from "./ChatWidget";
import BackToTop from "./BackToTop";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FBFBF9]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppBubble />
      <ChatWidget />
      <BackToTop />
    </div>
  );
}
